import MiFilterSelect from './MiFilterSelect.vue'

export default MiFilterSelect
